import { Radio, Stack, Typography } from "@mui/material";
import theme from "../theme/theme";

interface Props {
  label?: string | null;
  checked?: boolean;
  onClick?: () => void;
  containerStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  checkedColor?: string;
}

const CustomRadio: React.FC<Props> = ({
  label,
  checkedColor,
  checked,
  onClick,
  containerStyle,
  labelStyle
}) => {
  return (
    <Stack
      direction="row"
      alignItems={"center"}
      sx={{
        cursor: "pointer",
        ...containerStyle,
      }}
      onClick={onClick}
    >
      <Radio
        checked={checked}
        sx={{
          padding: 0,
          "&.Mui-checked": {
            color: checkedColor || theme.colors.primary,
          },
        }}
      />
      <Typography
        sx={{
          color: "#344051",
          mx: "12px",
          fontSize: 13,
          ...labelStyle
        }}
      >
        {label}
      </Typography>
    </Stack>
  );
};
export default CustomRadio;
